/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1MoneyMarketScheduleVersionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_VERSION_EVENT_ENTITY_NAME = 'ixf.hours.v1.MoneyMarketScheduleVersionEvent';
export const ixfHoursV1MoneyMarketScheduleVersionEventEntity = new schema.Entity<IxfHoursV1MoneyMarketScheduleVersionEvent>(IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_VERSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1MoneyMarketScheduleVersionEvent) => `${entity.metadata?.eventId}` });

